import React from 'react'

import './popin-wrapper.styles.scss'

const PopinWrapper = ({ children, id, ...otherProps }) => {
  const popinCloseHandler = (event) => {
    const targetElement = event.target
    let wrapper = targetElement.closest('.popin-wrapper')
    wrapper.removeAttribute('data-open')
  }

  return (
    <div className='popin-wrapper' id={id}>
      <div className='popin-container'>
        <div className='popin-header'>
          <svg
            className='popin-close'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            xmlns='http://www.w3.org/2000/svg'
            onClick={popinCloseHandler}
          >
            <path d='M1 1L19 19' />
            <path d='M19 1L1 19' />
          </svg>
        </div>
        <div className='popin-content'>{children}</div>
      </div>
      <div className='popin-overlay' onClick={popinCloseHandler} />
    </div>
  )
}

export default PopinWrapper
